import moment from "moment/moment";
import useIsDentist from "./useIsDentist";

const START = '2025-12-10T13:00:00';
const END = '2026-01-01T00:00:00';

export default function useIsSanta() {
    const isDentist = useIsDentist();

    if (!isDentist) return false;

    const now = moment().valueOf();
    const start = moment(START).valueOf();
    const end = moment(END).valueOf();
    return now >= start && now < end;
}